import makeRequest from './'

export default {
  getVideos(user) {
    return makeRequest('pages/videos?select=num,content,id,status', user)
  },

  getFiles(user) {
    return makeRequest('pages/downloads?select=num,content,id,status', user)
  }
}
